import { render, staticRenderFns } from "./DownloadLessons.vue?vue&type=template&id=47670bc6&scoped=true"
import script from "./DownloadLessons.vue?vue&type=script&lang=ts"
export * from "./DownloadLessons.vue?vue&type=script&lang=ts"
import style0 from "./DownloadLessons.vue?vue&type=style&index=0&id=47670bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47670bc6",
  null
  
)

export default component.exports